module.exports = __webpack_public_path__ + "static/img/UTSC教室_2.dd72d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC教室_2.png
// module id = nSsX
// module chunks = 0